import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import {
  UpsertContentMutation,
  UpsertContentMutationVariables,
} from '../gql/graphql';
import { GET_CONTENTS } from './content.query';

export const UPSERT_CONTENT = graphql(`
  mutation upsertContent($details: ContentInput!) {
    upsertContent(details: $details) {
      uuid
    }
  }
`);

export function useUpsertContentMutation(
  options: MutationHookOptions<
    UpsertContentMutation,
    UpsertContentMutationVariables
  > = {}
) {
  const [upsertContent, { loading, error, reset }] = useMutation(
    UPSERT_CONTENT,
    {
      refetchQueries: [GET_CONTENTS],
      awaitRefetchQueries: true,
      ...options,
    }
  );

  return {
    upsertContent,
    loading,
    error,
    reset,
  };
}
